import styled from '@emotion/styled';
import { Fonts, mediaQuery, Spacings } from '@styles/index';
import {
  Filter,
  FilterInput,
  FilterList,
  FilterOption
} from 'aquilla/core/molecules/Filter';
import Tick from 'aquilla/icons/actions/Tick';
import Typography from 'aquilla/core/atoms/Typography';

const StyledFilterInput = styled(FilterInput)`
  padding: 7px ${Spacings.SPACING_4B};
  gap: ${Spacings.SPACING_2B};
  min-width: 154px;
  max-width: 350px;
  height: 40px;
  border: ${Spacings.SPACING_1} solid;
  border-color: ${({ $isSelected }) =>
    $isSelected ? 'var(--color-text-primary)' : 'var(--color-divider)'};
  & > .p2_variant {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: ${({ $isSelected }) =>
      $isSelected ? `${Fonts.SEMIBOLD}` : `${Fonts.REGULAR}`};
  }

  ${mediaQuery.uptoMobile} {
    max-width: 155px;
  }
`;

const StyFilterList = styled(FilterList)`
  min-width: 202px !important;
  max-width: 350px;
  max-height: 265px;
  overflow: auto;
  top: 40px !important;
  left: 0 !important;
  z-index: 1;
  margin-top: ${Spacings.SPACING_2B};
  li:first-child a {
    display: none;
  }
`;

const StyledFilter = styled(Filter)`
  min-width: 154px;
  max-width: 350px;
  width: auto;
  position: relative;
`;

const IconWrapper = styled.div`
  margin-left: ${Spacings.SPACING_2B};
`;

const Title = styled(Typography)`
  font-weight: ${(props) => (props.$isSelected ? '600' : '400')};
  color: var(--color-text-primary);
`;

const getLabel = (filterList, value) => {
  return filterList.find((menuItem) => menuItem?.id === value?.id)?.name || '';
};

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const DEFAULT_FILTER_ID = -1;

const FilterBox = ({
  filterList,
  handleFilterSelect,
  selectedValue,
  placeholder
}) => {
  return (
    <>
      <StyledFilter
        value={getLabel(filterList, selectedValue)}
        onSelect={handleFilterSelect}
        placeholder={placeholder}
      >
        <StyledFilterInput
          $isSelected={selectedValue.id !== DEFAULT_FILTER_ID}
        />
        <StyFilterList>
          {filterList?.map((item) => {
            const isSelected = item.id === selectedValue.id;
            return (
              <FilterOption key={item.id} value={item}>
                <Container>
                  <Title variant="p2" $isSelected={isSelected}>
                    {item.name}
                  </Title>
                  {isSelected && (
                    <IconWrapper>
                      <Tick />
                    </IconWrapper>
                  )}
                </Container>
              </FilterOption>
            );
          })}
        </StyFilterList>
      </StyledFilter>
    </>
  );
};

export default FilterBox;
